import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../store";

const selectAreaState = (state: RootState) => state.area;

export const selectSelectedFranchise = createSelector(
  selectAreaState,
  areaState => areaState.selectedFranchise,
);
